import { render } from "./what-email-from.vue?vue&type=template&id=dda3c68e&lang=pug"
import script from "./what-email-from.vue?vue&type=script&lang=js"
export * from "./what-email-from.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__